import { Link, navigate } from "gatsby"
import React, { useContext } from "react"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { FirebaseContext } from "./firebase"
import Avatar from "@material-ui/core/Avatar"
import Tooltip from "@material-ui/core/Tooltip"
import { blueGrey } from "@material-ui/core/colors"
import Logo from "../images/FinalsScoreFSlogo.png"
import Hidden from "@material-ui/core/Hidden"
import Container from "@material-ui/core/Container"

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      marginTop: "7px",
      marginLeft: ".5em",
    },
  })
)

const Header = ({ siteTitle }) => {
  const { firebase, user } = useContext(FirebaseContext)
  const classes = useStyles()
  const handleLogout = () => {
    firebase.logout().then(() => navigate("/"))
  }

  return (
    <AppBar
      position="sticky"
      elevation={1}
      style={{
        backgroundColor: "white",
      }}
    >
      <Container>
        <Toolbar
          style={{
            alignItems: "flex-start",
            paddingTop: 10,
            paddingBottom: 20,
          }}
        >
          <Hidden smDown>
            <img src={Logo} alt="TFS logo" style={{ width: 50, height: 50 }} />

            <Typography variant="h6" className={`headerTitle ${classes.title}`}>
              <Link
                to="/"
                style={{
                  color: `var(--green)`,
                  textDecoration: `none`,
                }}
              >
                {siteTitle}
              </Link>
            </Typography>
          </Hidden>
          {!!user && !!user.email && (
            <Tooltip title={`Logged in as ${user.username || user.email}`}>
              <Avatar
                variant="circle"
                style={{
                  backgroundColor: blueGrey[100],
                  color: blueGrey[900],
                  marginRight: ".5em",
                }}
              >
                {user.username
                  ? user.username[0].toUpperCase()
                  : user.email[0].toUpperCase()}
              </Avatar>
            </Tooltip>
          )}
          <Button color="inherit" size="small" style={{ marginTop: "5px" }}>
            <Link
              to="/games"
              style={{
                color: `var(--green)`,
                textDecoration: `none`,
              }}
            >
              Games
            </Link>
          </Button>
          <Button color="inherit" size="small" style={{ marginTop: "5px" }}>
            <Link
              to="/faqs"
              style={{
                color: `var(--green)`,
                textDecoration: `none`,
              }}
            >
              FAQ
            </Link>
          </Button>
          {!!user && !!user.email ? (
            <div>
              <Button
                color="inherit"
                onClick={handleLogout}
                size="small"
                style={{ marginTop: "5px", color: `var(--green)` }}
              >
                Logout
              </Button>
            </div>
          ) : (
            <div>
              <Button color="inherit" size="small">
                <Link
                  to="/login"
                  style={{
                    color: `var(--green)`,
                    textDecoration: `none`,
                    marginTop: "5px",
                  }}
                >
                  Login
                </Link>
              </Button>
            </div>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Header
